import React, { useEffect, useState } from "react";
import api, { formatPrice } from "@/lib/api";
import { useLang } from "@/i18n";
import { useCart } from "@/context/CartContext";
import { useCurrency } from "@/context/CurrencyContext";
import { toast } from "sonner";
import { Gift } from "lucide-react";

const heroGift = "https://static.prod-images.emergentagent.com/jobs/9449b87b-68e6-4395-9435-2a889042c42d/images/fdc9f4b100b1b5f6f557db57f0569b002c156f922de4bd459ca6699f6163565c.png";

export default function Gifts() {
  const { t, tl } = useLang();
  const { addItem } = useCart();
  const { format } = useCurrency();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { category: "giftcards" } })
      .then((res) => setCards(res.data.sort((a, b) => a.price - b.price)));
  }, []);

  return (
    <div className="fade-up min-h-[60vh]">
      <section className="relative h-[46vh] min-h-[340px] overflow-hidden">
        <img src={heroGift} alt="Gift cards" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/35" />
        <div className="relative h-full px-4 sm:px-8 lg:px-16 flex flex-col justify-center items-center text-center">
          <Gift className="w-8 h-8 text-white mb-4" strokeWidth={1.2} />
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-none mb-4">{t("gifts_title")}</h1>
          <p className="text-base text-white/85 max-w-lg leading-relaxed">{t("gifts_sub")}</p>
        </div>
      </section>

      <section className="px-4 sm:px-8 lg:px-16 py-16 lg:py-24">
        <h2 className="text-xs tracking-luxe uppercase text-[#C5A880] text-center mb-10">{t("gift_choose")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {cards.map((card) => (
            <div key={card.id} data-testid={`gift-card-${card.id}`} className="bg-white border border-[#EAE6E1] p-8 flex flex-col items-center text-center group hover:border-[#C5A880] transition-colors duration-300">
              <div className="w-full aspect-[4/3] bg-[#F0EAE1] overflow-hidden mb-6">
                <img src={card.images?.[0]} alt={tl(card.name)} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <span className="font-serif-display text-3xl text-[#1A1F2C] mb-1">{format(card.price)}</span>
              <p className="text-xs text-[#6B7280] leading-relaxed mb-6 min-h-[48px]">{tl(card.description)}</p>
              <button
                data-testid={`gift-add-${card.id}`}
                onClick={() => { addItem(card); toast.success(t("added_to_cart")); }}
                className="w-full bg-[#1A1F2C] text-white text-xs tracking-luxe uppercase py-3 hover:bg-[#C5A880] transition-colors duration-300"
              >
                {t("add_to_cart")}
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
